export default "__VITE_ASSET__dqiawCMp__"